import { render, staticRenderFns } from "./CalcLogic.vue?vue&type=template&id=705e0fb9&scoped=true"
import script from "./CalcLogic.vue?vue&type=script&lang=js"
export * from "./CalcLogic.vue?vue&type=script&lang=js"
import style0 from "./CalcLogic.vue?vue&type=style&index=0&id=705e0fb9&prod&scoped=true&lang=less"
import style1 from "./CalcLogic.vue?vue&type=style&index=1&id=705e0fb9&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "705e0fb9",
  null
  
)

export default component.exports